/**
 * Matching band upsell:
 * - See more / See less
 * - Sync card metal / image / price / variantId to ring Metal Type
 */
(function () {
  function normalizeMetal(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getMetalTone(value) {
    var key = normalizeMetal(value);
    if (!key) return 'default';
    if (/rose|pink/.test(key)) return 'rose';
    if (/yellow|y\.?\s*g\b|yg\b/.test(key)) return 'yellow';
    if (/platinum|\bpt\b|silver|white|wg\b/.test(key)) return 'white';
    return 'default';
  }

  function parseMetalMap(card) {
    var raw = card.getAttribute('data-metal-variants');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function getMetalFromVariant(variant) {
    if (!variant) return '';
    var candidates = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    for (var i = 0; i < candidates.length; i++) {
      if (/\b(9k|14k|18k|platinum|\bpt\b)/i.test(String(candidates[i]))) {
        return String(candidates[i]);
      }
    }
    if (Array.isArray(variant.options)) {
      for (var j = 0; j < variant.options.length; j++) {
        if (/\b(9k|14k|18k|platinum|\bpt\b)/i.test(String(variant.options[j]))) {
          return String(variant.options[j]);
        }
      }
    }
    return variant.option1 || '';
  }

  function getMetalFromProductForm() {
    var fieldsets = document.querySelectorAll(
      '.product-form__input--metal-swatch, fieldset.product-form__input'
    );
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var legend = (fs.querySelector('legend') || {}).textContent || '';
      var isMetal =
        fs.classList.contains('product-form__input--metal-swatch') ||
        /metal|gold|platinum|karat/i.test(legend);
      if (!isMetal) continue;
      var checked = fs.querySelector('input:checked');
      if (checked) {
        var label = fs.querySelector('label[for="' + checked.id + '"]');
        var value =
          checked.value ||
          (label && (label.getAttribute('data-value') || label.textContent)) ||
          '';
        // Prefer the full option value from input value (Shopify uses option value)
        if (checked.value) return checked.value;
        return String(value).trim();
      }
    }

    var selectedJson = document.querySelector('variant-selects [data-selected-variant]');
    if (selectedJson && selectedJson.textContent) {
      try {
        return getMetalFromVariant(JSON.parse(selectedJson.textContent));
      } catch (e) {}
    }
    return '';
  }

  function updateCardForMetal(card, metalValue) {
    var map = parseMetalMap(card);
    if (!map) return;

    var key = normalizeMetal(metalValue);
    var entry = map[key];

    // Soft fallback: match by karat + color words if exact key missing
    if (!entry && key) {
      var keys = Object.keys(map);
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] === key || keys[i].indexOf(key) !== -1 || key.indexOf(keys[i]) !== -1) {
          entry = map[keys[i]];
          break;
        }
      }
    }

    if (!entry) return;

    var wasSelected = card.classList.contains('is-selected');
    card.dataset.variantId = String(entry.variantId);
    card.setAttribute('data-variant-id', String(entry.variantId));
    card.setAttribute('data-matching-band-offer', entry.isOffer ? 'true' : 'false');

    var available = !!entry.available;
    card.classList.toggle('is-unavailable', !available);
    card.disabled = !available;
    if (!available && wasSelected) {
      card.classList.remove('is-selected');
      card.setAttribute('aria-pressed', 'false');
    }

    var img = card.querySelector('.matching-band-upsell__image');
    if (img && entry.image) {
      img.src = entry.image;
      img.setAttribute('srcset', '');
      img.removeAttribute('srcset');
    }

    var metalEl = card.querySelector('[data-matching-band-metal]');
    if (metalEl) {
      var metalLabel = entry.metal || metalValue || '';
      if (metalLabel) {
        metalEl.textContent = metalLabel;
        metalEl.hidden = false;
        metalEl.setAttribute('data-metal-tone', getMetalTone(metalLabel));
      } else {
        metalEl.textContent = '';
        metalEl.hidden = true;
        metalEl.removeAttribute('data-metal-tone');
      }
    }

    var priceWrap = card.querySelector('[data-matching-band-price]');
    if (priceWrap && entry.priceHtml) {
      var note = priceWrap.querySelector('.matching-band-upsell__price-note');
      var noteHtml = note ? note.outerHTML : '';
      if (entry.isOffer && entry.compareHtml) {
        priceWrap.innerHTML =
          '<s class="brand-product-card__compare" data-matching-band-compare>' +
          entry.compareHtml +
          '</s>' +
          '<span class="brand-product-card__price" data-matching-band-sale>' +
          entry.priceHtml +
          '</span>' +
          noteHtml;
      } else {
        priceWrap.innerHTML =
          '<span class="brand-product-card__price" data-matching-band-sale>' +
          entry.priceHtml +
          '</span>' +
          noteHtml;
      }
    }

    var badge = card.querySelector('.brand-product-card__badge');
    var pct = Number(entry.discountPercent) || Number(card.dataset.upsellDiscountPercent) || 0;
    if (badge) {
      if (pct > 0 && entry.isOffer) {
        badge.hidden = false;
        badge.textContent = pct + '% OFF';
      } else if (!entry.isOffer) {
        badge.hidden = true;
      }
    }
  }

  function syncAllCardsToMetal(metalValue, scope) {
    var metal = metalValue || getMetalFromProductForm();
    if (!metal) return;
    (scope || document).querySelectorAll('[data-matching-band][data-metal-variants]').forEach(function (card) {
      updateCardForMetal(card, metal);
    });

    // Refresh persisted upsell selection ids after variant id swaps
    document.querySelectorAll('[data-product-upsells]').forEach(function (group) {
      if (!group.querySelector('[data-matching-band]')) return;
      try {
        var ids = [];
        group.querySelectorAll('[data-product-upsell].is-selected').forEach(function (card) {
          var id = Number(card.dataset.variantId);
          if (id) ids.push(id);
        });
        var key = 'dfe-product-upsells:' + (group.dataset.productId || '');
        sessionStorage.setItem(key, JSON.stringify(ids));
      } catch (e) {}
    });
  }

  function initExpand(root) {
    var list = root.querySelector('[data-matching-band-list]');
    var toggle = root.querySelector('[data-matching-band-expand]');
    if (!list || !toggle || toggle.dataset.bound === 'true') return;

    toggle.dataset.bound = 'true';
    var limit = parseInt(root.getAttribute('data-matching-band-limit'), 10) || 3;
    var expanded = false;

    function apply() {
      var items = list.querySelectorAll('[data-matching-band-item]');
      items.forEach(function (item, index) {
        var hide = !expanded && index >= limit;
        item.hidden = hide;
        item.classList.toggle('is-collapsed', hide);
      });
      toggle.textContent = expanded ? 'See less' : 'See more';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      root.classList.toggle('is-expanded', expanded);

      var visibleCount = expanded ? items.length : Math.min(items.length, limit);
      var gridCount = Math.min(visibleCount, 3);
      list.className = list.className.replace(/matching-band-upsell__grid--count-\d+/g, '');
      list.classList.add('matching-band-upsell__grid');
      list.classList.add('product-upsells__grid');
      list.classList.add('matching-band-upsell__grid--count-' + Math.max(gridCount, 1));
    }

    toggle.addEventListener('click', function () {
      expanded = !expanded;
      apply();
    });

    apply();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-matching-band-upsell]').forEach(initExpand);
    syncAllCardsToMetal(null, scope || document);
  }

  function onVariantChange(event) {
    var variant = event && event.data && event.data.variant;
    var metal = getMetalFromVariant(variant) || getMetalFromProductForm();
    syncAllCardsToMetal(metal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.tagName !== 'INPUT') return;
    var fieldset = input.closest('.product-form__input');
    if (!fieldset) return;
    var legend = (fieldset.querySelector('legend') || {}).textContent || '';
    var isMetal =
      fieldset.classList.contains('product-form__input--metal-swatch') ||
      /metal|gold|platinum|karat/i.test(legend);
    if (!isMetal) return;
    // Wait a tick so Dawn can update selected variant JSON
    setTimeout(function () {
      syncAllCardsToMetal(input.value || getMetalFromProductForm());
    }, 50);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }
})();
